/*
 * Project: BookingEngine
 * Module: components/common/ShareDownload.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ShareBtn from '../ds/molecules/btn/ShareBtn';
import {
  downloadVoucher,
} from '../../actions/Booking';

class ShareDownload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadStatus: '',
    };
  }

  onClickDownload() {
    if (this.state.downloadStatus === 'downloading') {
      return;
    }
    this.setState({ downloadStatus: 'downloading' });
    const { locator, lang, is_agent_voucher } = this.props;
    this.props.downloadVoucher({ locator, lang, is_agent_voucher }).then(() => {
      this.setState({ downloadStatus: '' });
    });
  }

  render() {
    const {
      className, is_agent_voucher,
    } = this.props;
    const isDowloading = this.state.downloadStatus === 'downloading';
    let label = isDowloading ? this.context.t('downloading PDF ...') : this.context.t('download as PDF');

    if (this.props.editBooking != null && this.props.editBooking.agent_code != null
      && this.props.editBooking.agent_code !== ''
      && this.props.editBooking.agent_sell != null && this.props.editBooking.agent_sell === true
      && this.props.editBooking.who_is_viewing === 'AGENT'
      && is_agent_voucher === false) {
      label = isDowloading ? this.context.t('downloading PDF ...') : this.context.t('Download Client Voucher PDF'); //traducir
    }
    if (this.props.editBooking != null && this.props.editBooking.agent_code != null
      && this.props.editBooking.agent_code !== ''
      && this.props.editBooking.agent_sell != null && this.props.editBooking.agent_sell === true
      && this.props.editBooking.who_is_viewing === 'AGENT'
      && is_agent_voucher === true) {
      label = isDowloading ? this.context.t('downloading PDF ...') : this.context.t('Download Agency Voucher PDF'); //traducir
    }
    return (
      <ShareBtn icon="download" className={className} label={label} onClick={() => this.onClickDownload()} />
    );
  }
}

ShareDownload.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  locator: state.booking.book_locator,
  lang: state.i18nState.lang,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  editBooking: state.booking.editBooking,
});

const mapDispatchToProps = (dispatch) => ({
  downloadVoucher: (payload) => dispatch(downloadVoucher(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareDownload);
